module.exports = __webpack_public_path__ + "img/none-module.bed9b7cb.svg";